import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth,  } from 'aws-amplify';
import { RootState } from '../../store/store';
import { Loading, sessionUpdated } from '../../App/app';
import { feedback } from '../../components/Feedback/feedback';
import { authenticateUser } from '../../store/api/authenticate-user';
import i18n from '../../i18n/i18n';
import { hgsKeyBackendUri } from '../../uris';
import apiMessage from '../../i18n/api/api-messages';
import { push } from '@lagunovsky/redux-react-router';

interface State {
  loading: Loading,
  currentRequestId: string,
  error: SerializedError | null,
}

const initialState: State = {
  loading: 'idle',
  currentRequestId: '',
  error: null,
}

interface Attributes {
  [id:string]: any,
}

interface CognitoUser {
  attributes: Attributes,
  authenticationFlowType: string,
}

export interface Credentials {
  username: string,
  password: string,
  token: string,
}

interface OnboardUserBody {
  firstname: string,
  lastname: string,
  password: string,
  token: string,
}

export const onboardUser = createAsyncThunk(
  'signUp/onboardUser', async( data: OnboardUserBody, thunkAPI ) => {
    const settingsT = i18n.getFixedT( null, 'settings');
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.signUp;

    if (loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return

    // const redirectURI = state.app.searchParameters.redirect_uri ? new URL(state.app.searchParameters.redirect_uri).origin : '';
    try {
      const response = await fetch(`${hgsKeyBackendUri}/onboardUser`, {
        method: 'POST',
        body: JSON.stringify({
          firstname: data.firstname,
          lastname: data.lastname,
          password: data.password,
          token: data.token,
        }),
        redirect: 'follow',
      });

      if (!response.ok) {
        const text = await response.text();
        const apiT = i18n.getFixedT(null, 'api');
        thunkAPI.dispatch(feedback({ message: apiT(apiMessage(text as any)), severity: 'error' }));
        return false;
      }

      const payload = await response.json();
      if (payload.VerificationEmailSent) {
        thunkAPI.dispatch(push('/sign-up/success'));
      } else {
        thunkAPI.dispatch(push('/sign-up/complete'));
      }
      return true;

    } catch (error) {
      const message = typeof error === 'string' ? error : (error as Error).message;
      const apiT = i18n.getFixedT(null, 'api');
      thunkAPI.dispatch(feedback({ message: apiT(apiMessage(message as any)), severity: 'error' }));
      return false;
    }
  }
);

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
  },
  extraReducers: ( builder ) => {
      builder.addCase( onboardUser.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase( onboardUser.fulfilled, (state, action) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          state.currentRequestId = ''
        }
      })
      .addCase( onboardUser.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if (
          state.loading === 'pending' &&
          state.currentRequestId === requestId
        ) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const { } = signUpSlice.actions

export default signUpSlice.reducer
